import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { fetchWithTimeout } from "../../App";

const API_URL = process.env.REACT_APP_API_URL;

function AdminGuard({ children }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    fetchWithTimeout(`${API_URL}/api/admin/me`, { credentials: "include" }, 5000)
      .then((res) => {
        if (res.ok) setStatus("ok");
        else setStatus("denied");
      })
      .catch(() => setStatus("denied"));
  }, []);

  if (status === "checking") {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--cream)",
        color: "var(--text-muted)",
        fontFamily: "'Lato', sans-serif",
        flexDirection: "column",
        gap: "0.75rem",
      }}>
        <div style={{ fontSize: "2rem" }}>🍝</div>
        <span>Checking access...</span>
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default AdminGuard;
